<!-- <p>edit-virtual-sensor works!</p> -->
<app-dialog-header headerIcon="mediation" headerText="Edit Virtual DataPoint"
    (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
    <div class="main" #DialogContainer id="DialogContainer">
        <div class="content">
            <mat-form-field appearance="fill">
                <mat-label>Name</mat-label>
                <input matInput autocomplete="off" formControlName="virtualSensorName">
            </mat-form-field>
            <div class="datapoints-box alignColumn">
                <ejs-multiselect [mode]="'Box'" [fields]='dpFields' *ngIf="datapoints.length > 0"
                    placeholder="Choose Input DataPoints" [dataSource]="datapoints" [value]="selectedDpIDs"
                    (change)="datapointChoiceChange($event)">
                </ejs-multiselect>
                <span>Input DataPoints</span>
            </div>
            <div class="datapoint-item alignRow" *ngFor="let datapoint of selectedDatapoints">
                <span>{{datapoint.DPTitle}}</span>
                <ejs-dropdownlist id="dropdown" #dropdown [fields]="datapointNumberFields"
                    [dataSource]='datapointNumberOptions' [value]="getValueForDP(datapoint)"
                    (change)="dataPointNumberChange($event, datapoint.DataPointID)">
                </ejs-dropdownlist>
            </div>
            <div class="option-buttons">
                <button mat-raised-button *ngFor="let option of conversionOptions"
                    (click)="writeToConversion(option.value)">
                    <span>{{option.label}}</span>
                </button>
            </div>
            <div class="option-buttons">
                <ng-container *ngFor="let dp of selectedDatapoints">
                    <button mat-raised-button *ngIf="getValueForDP(dp) != 0"
                        (click)="writeLabelToConversion(getValueForDP(dp))">
                        <span>[{{getValueForDP(dp)}}]</span>
                    </button>
                </ng-container>
            </div>
            <div class="custom-value">
                <ejs-numerictextbox [step]="1" cssClass="e-custom" [(value)]="customInputValue">
                </ejs-numerictextbox>
                <button mat-raised-button (click)="writeToConversion(customInputValue.toString())">Add Custom
                    Value</button>
                <span class="toolbar-spacer"></span>
                <button mat-raised-button class="alignRow" style="margin: auto;" (click)="backspaceConversion()"><mat-icon>west</mat-icon></button>
            </div>
            <div class="conversion-box">
                <mat-form-field>
                    <mat-label>Conversion</mat-label>
                    <textarea matInput formControlName="conversion" [readonly]="true"
                        [value]="conversionText"></textarea>
                </mat-form-field>
            </div>
            <div class="SI-box">
                <mat-form-field>
                    <mat-label>Units</mat-label>
                    <textarea matInput formControlName="SI"></textarea>
                </mat-form-field>
            </div>
        </div>

        <div mat-dialog-actions>
            <button mat-button [mat-dialog-close]="dialogForm.value"
                [disabled]="dialogForm.invalid || !dialogForm.dirty ">Ok</button>
            <button mat-button (click)="onCancelClick()">Cancel</button>
        </div>
    </div>
</form>